import React, { FC } from "react";
import { DIVIDER } from "baseui/table-semantic";
import { Link } from "kanopi-components/Link";
import { TableBuilder } from "kanopi-components/TableView/TableView";
import { useFormatter } from "kw/util/useFormatter";

type TAdminDocumentsSection = {
  documents: TGeneratedDocumentType[];
};
export const AdminDocumentsSection: FC<TAdminDocumentsSection> = ({ documents }) => {
  const { formatDate } = useFormatter();
  const columnSchema = [
    {
      header: "Name",
      id: "id",
      children: (row: TGeneratedDocumentType) => (
        <Link
          onClick={() => {
            window.open(row?.url, "_blank");
          }}
        >
          {row.name}
        </Link>
      ),
      sortable: false,
    },
    {
      header: "Created",
      id: "created",
      children: (row: TGeneratedDocumentType) => formatDate(row?.created),
      sortable: false,
    },
  ];
  return (
    <TableBuilder
      columnSchema={columnSchema}
      data={documents}
      showSearchSection={false}
      showPagination={false}
      emptyMessage="No documents found"
      data-testid="tableView-DOCUMENT"
      divider={DIVIDER.clean}
    />
  );
};
